/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { stepMedicalExpenseCFLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const medicalExpenses = mapToMedicalExpenseStep(data);

  return [...medicalExpenses];
}

function mapToMedicalExpenseStep(data) {
  const expenses = [];
  if (data.expenseDescriptionOfItems.length < 1) {
    return expenses;
  }
  const claimCode = expenseLookup.medicalExpenseCF.claimCode;
  data.expenseDescriptionOfItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );
  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateIncurred, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor;
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.id);
  if (!item || !item.amountClaimed || !item.currencyExpensesClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.nameOfProvider}`,
    dateOfExpense: item.dateIncurred,
    clientCost: item.amountClaimed,
    currency: item.currencyExpensesClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalExpenseCFDataMapper.js